import React from 'react';
const bonuses = [{
  title: 'Plan de Alimentación Complementario',
  description: 'Aprende cómo organizar tus comidas y desarrollar hábitos que acompañen un enfoque integral del manejo del peso.',
  image: 'https://cdn.magicpatterns.com/uploads/qt2e2WUWieochgJ7Z6qpVQ/ChatGPT_Image_Jul_1,_2026,_03_06_00_AM.png',
  eyebrow: 'Bono 01'
}, {
  title: 'Diario de Seguimiento de 90 Días',
  description: 'Registra tu evolución, hábitos y objetivos para mantenerte enfocado y medir tu progreso.',
  image: 'https://cdn.magicpatterns.com/uploads/fJMGcju5Av4tZUJtcDGmj8/ChatGPT_Image_Jul_1,_2026,_03_09_36_AM.png',
  eyebrow: 'Bono 02'
}, {
  title: 'Las 50 Preguntas Más Frecuentes sobre GLP-1',
  description: 'Respuestas claras a las dudas que la mayoría de las personas tiene antes y durante un tratamiento.',
  image: 'https://cdn.magicpatterns.com/uploads/7P3ueN56EoLqxDGGALcANi/ChatGPT_Image_Jul_1,_2026,_03_07_50_AM.png',
  eyebrow: 'Bono 03'
}, {
  title: 'Protocolos Educativos de Medicina Metabólica',
  description: 'Conoce cómo suele iniciarse un tratamiento con GLP-1, la importancia del ajuste gradual de dosis, recomendaciones nutricionales y otros principios utilizados en la práctica clínica.',
  image: 'https://cdn.magicpatterns.com/uploads/mWcBGc2y4M544SRuu8i3Qr/ChatGPT_Image_Jul_1,_2026,_03_04_20_AM.png',
  eyebrow: 'Bono 04'
}];
export function Bonuses() {
  return <div className="bg-ivory-dark py-24 border-y border-gold/10" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-20" data-id="element-3">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-gold font-medium mb-6" data-id="element-4">
            Exclusivo
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif text-ink mb-6" data-id="element-5">
            Además recibirás sin costo adicional
          </h2>
          <p className="text-lg text-ink/70 max-w-2xl mx-auto font-light" data-id="element-6">
            Complementa tu aprendizaje con estas herramientas prácticas
            diseñadas para maximizar tus resultados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-7">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white border border-gold/20 shadow-sm overflow-hidden flex flex-col sm:flex-row hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 group" data-id="element-8">
              {/* Striking image panel — rich ink backdrop makes the covers pop */}
              <div className="relative w-full sm:w-72 flex-shrink-0 bg-ink flex items-center justify-center p-6 sm:p-5 overflow-hidden" data-id="element-9">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(34,122,130,0.35),transparent_70%)]" data-id="element-10"></div>
                <span className="absolute top-4 left-4 text-[10px] tracking-[0.2em] uppercase text-gold/90 font-medium z-10" data-id="element-11">
                  {bonus.eyebrow}
                </span>
                <img src={bonus.image} alt={bonus.title} className="relative z-10 w-full max-w-[16rem] object-contain drop-shadow-[0_24px_40px_rgba(0,0,0,0.6)] group-hover:scale-110 group-hover:-rotate-1 transition-transform duration-500" data-id="element-12" />
                <span className="absolute bottom-0 left-0 right-0 h-1 bg-gold" data-id="element-13"></span>
              </div>
              <div className="text-center sm:text-left flex-1 p-8 sm:p-10 flex flex-col justify-center" data-id="element-14">
                <h3 className="text-2xl font-serif text-ink mb-4 leading-snug" data-id="element-15">
                  {bonus.title}
                </h3>
                <p className="text-ink/70 text-sm leading-relaxed font-light" data-id="element-16">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}